if (!window?.hasOwnProperty("STORE_SUBSCRIPTION")) {
  window["STORE_SUBSCRIPTION"] = {};
}

// document.addEventListener("DOMContentLoaded", (event) => {
//   setTimeout(() => {
//     injectChevronSVGIntoFacetsLabel();
//     observeAndChangeSliderRangeTrackStyle();
//   }, 5000);

//   window.navigation.addEventListener("navigate", (event) => {
//     console.log('location changed!');
//     setTimeout(() => {
//       observeAndChangeSliderRangeTrackStyle();
//     }, 500);
//   })
// });

function injectChevronSVGIntoFacetsLabel() {
  Array.from(document.querySelectorAll(".boost-sd__filter-option-title")).forEach(el => {
    el.insertAdjacentHTML("beforeend", `
    <svg id="BoostFiltersChevron" style="margin-left: auto;" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.9998 10.8164L7.99976 6.81641L3.99975 10.8164" stroke="#00335C" stroke-width="1.57091" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `);
  });
}

function observeAndChangeSliderRangeTrackStyle() {
  const baseEl = document.querySelectorAll(".noUi-base");
  
  if (baseEl) {
    baseEl.forEach(ele => {
      addRangeIndicatorOnPriceRangeSlider(ele);
    });
    

    const observer = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === "attributes") {
          if (mutation.attributeName === 'aria-valuetext') {
             baseEl.forEach(ele => {
              addRangeIndicatorOnPriceRangeSlider(ele);
            });
          }
        }
      }
    });

    observer.observe(baseEl, {
      attributes: true, childList: true, subtree: true
    });
  }
}

function addRangeIndicatorOnPriceRangeSlider(ele) {
  function getPositionAtCenter(element) {
    const {top, left, width, height} = element.getBoundingClientRect();
    return {
      x: left + width / 2,
      y: top + height / 2
    };
  }
  
  function getDistanceBetweenElements(a, b) {
   const aPosition = getPositionAtCenter(a);
   const bPosition = getPositionAtCenter(b);
  
   return Math.hypot(aPosition.x - bPosition.x, aPosition.y - bPosition.y);  
  }
  
  let pointA = ele.querySelector(".noUi-handle-lower");
  let pointB = ele.querySelector(".noUi-handle-upper");
  let distance = getDistanceBetweenElements(
    pointA,
    pointB
  );
  console.log(pointA);
  console.log(distance);
  let finalDistance = distance - 15;
  pointA?.setAttribute("style", `--customSliderIndicationFinalDistance: ${finalDistance}px`);
  pointA?.classList.add("customSliderIndication");
}

const customize = {
   removeOOSProductSwatches: (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductSwatch', {
         name: 'Customize swatches',
         enabled: true,
         apply: () => ({
            props: (props) => {
               props.maxItem = 100; // Show all swatches by increasing number of swatches displayed to 100 (optional)
               return props;
            },
            afterRender(element) {
               const swatchOptions = element?.getParams()?.props?.options;
               const productData =
                  componentRegistry.getNearestParentElm(element, 'ProductItemWidget')?.getParams()?.props?.product ||
                  componentRegistry.getNearestParentElm(element, 'QuickView')?.getParams()?.props?.productData;
               if (swatchOptions?.length && productData) {
                  const productVariants = productData.variants || [];
                  swatchOptions.forEach((option) => {
                     const optionValue = option.value;
                     option.available = checkOptionStatus(productVariants, optionValue);
                     if (!option.available) {
                        const swatchOption = document.querySelector(`label[for*="${option.id}"]`);
                        if (swatchOption && swatchOption.closest('.boost-sd__product-swatch-option')) {
                           swatchOption.closest('.boost-sd__product-swatch-option').classList.add('sold-out');
                        }
                     }
                  });
               }
            },
         }),
      });
   },
};

function checkOptionStatus(variants, optionValue) {
   for (let i = 0; i < variants.length; i++) {
      const variant = variants[i];
      const variantOptions = variant.title?.split(' / ') || [];
      if (variantOptions.some((option) => option.toLowerCase() === optionValue.toLowerCase() && variant.available)) {
         return true;
      }
   }
   return false;
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
   customize.removeOOSProductSwatches,
]);